import { all, put, call, takeLatest } from 'redux-saga/effects';
import * as actions from 'reducer/actionTypes'
import * as api from 'script/api'

export default function* fetchUniAdapter() {

	yield all([
		takeLatest(actions.FETCH_GET_UNIADAPTER_ACTIVE_STATUS_REQUEST, getUniadapterActiveStatus),

		takeLatest(actions.FETCH_GET_SAMPLE_WEBOFFICE_URL_REQUEST, getSampleWebofficeURL),
		takeLatest(actions.FETCH_SET_SAMPLE_WEBOFFICE_URL_REQUEST, setSampleWebofficeURL),

		takeLatest(actions.FETCH_SET_RESET_UNIADAPTER_INTERFACE_REQUEST, setResetUniadapterInterface),

		takeLatest(actions.FETCH_GET_UNIADAPTER_HTTP_EXECUTE_REQUEST, executeUniAdapterRequest),
		takeLatest(actions.FETCH_GET_UNIADAPTER_PARAMETER_REQUEST, getUniAdapterParam),

		takeLatest(actions.FETCH_GET_UNIADAPTER_INTERFACE_REQUEST, getUniAdapterInterface),
		takeLatest(actions.FETCH_SET_UNIADAPTER_INTERFACE_REQUEST, setUniAdapterInterface),
		takeLatest(actions.FETCH_SET_UNIADAPTER_START_REQUEST, setUniAdapterStart),
		takeLatest(actions.FETCH_GET_UNIADAPTER_LIST_REQUEST, getUniAdapterList),

		takeLatest(actions.FETCH_GET_UNIADAPTER_EXPORT_REQUEST, exportUniAdapterInfo),
		takeLatest(actions.FETCH_SET_UNIADAPTER_IMPORT_REQUEST, importUniAdapterInfo),
		
		takeLatest(actions.FETCH_GET_UNIADAPTER_CONNECT_PARAMETERS_REQUEST, getUniAdapterConnectParameters),
		takeLatest(actions.FETCH_SET_UNIADAPTER_CONNECT_PARAMETERS_REQUEST, setUniAdapterConnectParameters),
	])
}

// Get uniAdapterActive: Activate the UniAdapter setting tab
function* getUniadapterActiveStatus(params) {
	try {
		const result = yield call(api.getSettingData, params)

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_GET_UNIADAPTER_ACTIVE_STATUS_FAILURE,
				error:result.messageId
			})
		} else {
			yield put({
				type: actions.FETCH_GET_UNIADAPTER_ACTIVE_STATUS_SUCCESS,
				value: result.data.value
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_GET_UNIADAPTER_ACTIVE_STATUS_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

// GET sampleWebofficeURL: URL for user testing
function* getSampleWebofficeURL(value) {
	try {
		const result = yield call(api.getSampleWebofficeURL, value.value)

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_GET_SAMPLE_WEBOFFICE_URL_FAILURE,
				error:result.messageId
			})
		} else {
			yield put({
				type: actions.FETCH_GET_SAMPLE_WEBOFFICE_URL_SUCCESS,
				value: result.data.value
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_GET_SAMPLE_WEBOFFICE_URL_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

// SET sampleWebofficeURL: URL for user testing
function* setSampleWebofficeURL(params) {
	try {
		const result = yield call(api.setSampleWebofficeURL, params)
		let isError = false;

		if (result.data.resultCode > 0) {
			isError = true;
			yield put({
				type: actions.FETCH_SET_SAMPLE_WEBOFFICE_URL_FAILURE,
				error:result.messageId
			})
		} else {
			isError = false;
			yield put({
				type: actions.FETCH_SET_SAMPLE_WEBOFFICE_URL_SUCCESS,
				value: params.value.webofficeURL
			})
		}

		// messageBox
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			resultCode: result.data.resultCode,
			message: result.data.messageId,
			isError: isError
		})
	}
	catch (error) {
		yield put({
			type: actions.FETCH_SET_SAMPLE_WEBOFFICE_URL_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

//setResetUniadapterInterface
function* setResetUniadapterInterface(params) {
	try {
		const result = yield call(api.setResetUniadapterInterface)
		let isError = false;

		if (result.data.resultCode > 0) {
			isError = true;
			yield put({
				type: actions.FETCH_SET_RESET_UNIADAPTER_INTERFACE_FAILURE,
				error:result.messageId
			})
		} else {
			isError = false;
			yield put({
				type: actions.FETCH_SET_RESET_UNIADAPTER_INTERFACE_SUCCESS,
			})
		}

		// messageBox
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			resultCode: result.data.resultCode,
			message: result.data.messageId,
			isError: isError
		})
	}
	catch (error) {
		yield put({
			type: actions.FETCH_SET_RESET_UNIADAPTER_INTERFACE_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

// Execute user http request
function* executeUniAdapterRequest(params) {
	try {
		const result = yield call(api.executeUniAdapterRequest, params)

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_GET_UNIADAPTER_HTTP_EXECUTE_SUCCESS,
				interfaceType: params.interfaceType,
				request: params.value,
				response: result.data.value
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

// Get : UniAdapter AdapterParam information
function* getUniAdapterParam(value) {
	try {
		const result = yield call(api.getUniAdapterParam, value.value)

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
			yield put({
				type: actions.FETCH_GET_UNIADAPTER_PARAMETER_FAILURE,
				error:result.messageId
			})
		} else {
			yield put({
				type: actions.FETCH_GET_UNIADAPTER_PARAMETER_SUCCESS,
				value: result.data.value
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_GET_UNIADAPTER_PARAMETER_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

// GET : UniAdapter interface information
//'info','get','put','lock','unlock','refresh',etc...
function* getUniAdapterInterface(params) {
	try {
		const result = yield call(api.getUniAdapterInterface, params)

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
			yield put({
				type: actions.FETCH_GET_UNIADAPTER_INTERFACE_FAILURE,
				error:result.messageId
			})
		} else {
			yield put({
				type: actions.FETCH_GET_UNIADAPTER_INTERFACE_SUCCESS,
				interfaceType: params.value.interfaceType,
				value: result.data.value
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_GET_UNIADAPTER_PARAMETER_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

// SET : UniAdapter interface information
//'info','get','put','lock','unlock','renew',etc...
function* setUniAdapterInterface(params) {
	try {
		const result = yield call(api.setUniAdapterInterface, params);
		let isError = false;

		if (result.data.resultCode > 0) {
			isError = true;
			yield put({
				type: actions.FETCH_SET_UNIADAPTER_INTERFACE_FAILURE,
				error:result.messageId
			})
		} else {
			isError = false;
			yield put({
				type: actions.FETCH_SET_UNIADAPTER_INTERFACE_SUCCESS,
				interfaceType: params.interfaceType,
				value: result.data.value
			})
		}

		// messageBox
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			resultCode: result.data.resultCode,
			message: result.data.messageId,
			isError: isError
		})
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_SET_UNIADAPTER_INTERFACE_FAILURE,
			interfaceType: params.interfaceType,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

// SET : UniAdapter 'start' and 'adapterParam' information
function* setUniAdapterStart(params) {
	try {
		const result = yield call(api.setUniAdapterStart, params);
		let isError = false;

		if (result.data.resultCode > 0) {
			isError = true
			yield put({
				type: actions.FETCH_SET_UNIADAPTER_START_FAILURE,
				error:result.messageId
			})
		} else {
			isError = false
			yield put({
				type: actions.FETCH_SET_UNIADAPTER_START_SUCCESS,
				value: result.data.value
			})
		}

		// messageBox
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			resultCode: result.data.resultCode,
			message: result.data.messageId,
			isError: isError
		})
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_SET_UNIADAPTER_START_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}


function* getUniAdapterList() {
	try {
		const result = yield call(api.getUniAdapterList)

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_GET_UNIADAPTER_LIST_SUCCESS,
				value: result.data.value
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_GET_UNIADAPTER_LIST_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* exportUniAdapterInfo(action) {
	try {
		const result = yield call(api.exportUniAdapterInfo, action.value.adapterName)

		if (result.status != 200) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			const blob = result.data;
			const fileHandle = action.value.fileHandle;

			if (fileHandle) {
				const writable = yield call([fileHandle, fileHandle.createWritable]);
				yield call([writable, writable.write], blob);
				yield call([writable, writable.close]);
			}

			yield put({
				type: actions.FETCH_GET_UNIADAPTER_EXPORT_SUCCESS
			});

			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "success",
				isError: false

			})
		}
	} catch (error) {
		yield put({
			type: actions.FETCH_GET_UNIADAPTER_EXPORT_FAILURE,
			error: error.message
		})
	} finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* importUniAdapterInfo(action) {
	try {
		const formData = new FormData();
		formData.append('file', action.value.file);

		const result = yield call(api.importUniAdapterInfo, formData);
		if (result.data.resultCode > 0) {
			yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			resultCode: result.data.resultCode,
			message: result.data.messageId,
			isError: true
		});
		} else {
			yield put({
			type: actions.FETCH_SET_UNIADAPTER_IMPORT_SUCCESS
			});
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: false
			})
		}
	} catch (error) {
		yield put({
		type: actions.FETCH_SET_UNIADAPTER_IMPORT_FAILURE,
		error: error.message
	});
	} finally {
		yield put({ type: actions.CLEAR_API_CALL_STATUS });
	}
}

function* setUniAdapterConnectParameters(actions) {
		try {
		const result = yield call(api.setUniAdapterConnectParameters, actions.value);
		let isError = false;
		let adapterName = actions.value.adapterName;

		if (result.data.resultCode > 0) {
			isError = true
			yield put({
				type: actions.FETCH_SET_UNIADAPTER_CONNECT_PARAMETERS_FAILURE,
				error:result.messageId
			})
		} else {
			isError = false
			yield put({
				type: actions.FETCH_SET_UNIADAPTER_CONNECT_PARAMETERS_SUCCESS,
				value: result.data.value
			});

			yield put({
				type: actions.FETCH_GET_UNIADAPTER_PARAMETER_REQUEST,
				value: adapterName
			});	
				
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_SET_UNIADAPTER_CONNECT_PARAMETERS_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* getUniAdapterConnectParameters(action){
	try {
		const result = yield call(api.getUniAdapterConnectParameters, action.value)

		if (result.status != 200) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: result.data.messageId,
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_GET_UNIADAPTER_CONNECT_PARAMETERS_SUCCESS,
				value: result.data.value
			});
		}
	} catch (error) {
		yield put({
			type: actions.FETCH_GET_UNIADAPTER_CONNECT_PARAMETERS_FAILURE,
			error: error.message
		})
	} finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}